/* Product-scoped behaviour. Shopify/Shrine owns pricing, variants and cart submissions. */
(() => {
  if (!customElements.get('pv-reviews')) {
    customElements.define('pv-reviews', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort(); this.abort = new AbortController();
        const opts = {signal: this.abort.signal};
        this.track = this.querySelector('.pv-review-track');
        this.pause = this.querySelector('[data-pause]');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.desktop = matchMedia('(min-width: 750px)');
        this.paused = false; this.hovered = false; this.inView = false; this.direction = 1; this.last = 0;
        const stop = () => { this.paused = true; this.update(); };
        this.querySelector('[data-next]').addEventListener('click', () => { stop(); this.move(1); }, opts);
        this.querySelector('[data-prev]').addEventListener('click', () => { stop(); this.move(-1); }, opts);
        this.pause.addEventListener('click', () => { this.paused = !this.paused; this.update(); }, opts);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.update(); }, opts);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.update(); }, opts);
        this.track.addEventListener('pointerdown', stop, opts);
        this.track.addEventListener('focusin', stop, opts);
        this.track.addEventListener('wheel', stop, opts);
        this.reduced.addEventListener('change', () => this.update(), opts);
        this.desktop.addEventListener('change', () => this.update(), opts);
        document.addEventListener('visibilitychange', () => this.update(), opts);
        document.addEventListener('shopify:block:select', e => { if (this.contains(e.target)) { stop(); e.target.scrollIntoView({block:'nearest',inline:'nearest'}); } }, opts);
        this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.update(); });
        this.observer.observe(this); this.update();
      }
      move(direction) { this.track.scrollBy({left: direction * (this.track.querySelector('article')?.getBoundingClientRect().width + 20 || 340), behavior:this.reduced.matches ? 'instant' : 'smooth'}); }
      update() {
        cancelAnimationFrame(this.raf);
        const enabled = this.dataset.autoplay === 'true' && this.desktop.matches && !this.reduced.matches;
        this.pause.hidden = !enabled;
        this.pause.textContent = this.paused ? 'Play' : 'Pause';
        this.pause.setAttribute('aria-label', this.paused ? 'Play review movement' : 'Pause review movement');
        const running = enabled && !this.paused && !this.hovered && this.inView && !document.hidden;
        this.track.style.scrollSnapType = running ? 'none' : 'x mandatory';
        this.last = 0;
        if (running) this.raf = requestAnimationFrame(t => this.tick(t));
      }
      tick(time) {
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (this.last && max > 1) {
          const step = Math.min(time-this.last,50)/1000 * (Number(this.dataset.speed)||12);
          let next=this.track.scrollLeft + step*this.direction;
          if(next>=max){next=max;this.direction=-1;} else if(next<=0){next=0;this.direction=1;}
          this.track.scrollLeft=next;
        }
        this.last=time;this.raf=requestAnimationFrame(t=>this.tick(t));
      }
      disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();cancelAnimationFrame(this.raf);}
    });
  }
  // Keep fragment links section-ID independent on uploaded Shopify themes.
  const resolveAnchors = () => {
    const main=document.querySelector('.pv-main'); if(!main)return;
    document.querySelectorAll('.pv-scope a[href="#MainProduct-main"]').forEach(a=>a.setAttribute('href','#'+main.id));
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',resolveAnchors,{once:true});else resolveAnchors();
  document.addEventListener('shopify:section:load',resolveAnchors);
})();
